export const boldFirstPart = (definition = '') => {
  if (!definition) return ''
  return definition.replaceAll(/<p>([^<:]+:)/g, '<p><b>$1</b>')
}
